import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Search, MapPin } from "lucide-react";
import { api } from "@/lib/api";
import { TechCard } from "@/components/TechCard";

export default function Explore() {
  const [q, setQ] = useState("");
  const [city, setCity] = useState("");
  const params = { q, city };
  const { data: techs = [], isLoading } = useQuery({ queryKey: ["techs", params], queryFn: () => api.get("/techs", { params }).then((r) => r.data) });

  return (
    <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-12">
      <p className="font-mono text-xs uppercase tracking-[0.2em] text-pink-600">Directory</p>
      <h1 className="mt-3 font-serif text-4xl tracking-tight sm:text-5xl">Find your nail tech</h1>
      <div className="mt-10 grid gap-3 rounded-2xl border border-[#EAE4DC] bg-white p-3 md:grid-cols-12">
        <label className="flex items-center gap-2 rounded-xl bg-stone-50 px-4 md:col-span-7">
          <Search className="h-4 w-4 text-stone-400" />
          <input data-testid="directory-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Name, handle or anything in their bio" className="h-11 w-full bg-transparent text-sm outline-none" />
        </label>
        <label className="flex items-center gap-2 rounded-xl bg-stone-50 px-4 md:col-span-5">
          <MapPin className="h-4 w-4 text-stone-400" />
          <input data-testid="directory-city-input" value={city} onChange={(e) => setCity(e.target.value)} placeholder="City, state or ZIP code" className="h-11 w-full bg-transparent text-sm outline-none" />
        </label>
      </div>
      <p data-testid="directory-count" className="mt-8 font-mono text-xs text-stone-500">{isLoading ? "Loading…" : `${techs.length} ${techs.length === 1 ? "tech" : "techs"}`}</p>
      <div className="mt-4 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
        {techs.map((t, i) => <TechCard key={t.id} tech={t} i={i} />)}
      </div>
      {!isLoading && techs.length === 0 && <p data-testid="directory-empty" className="py-20 text-center text-stone-500">No techs match yet — try a different city or style.</p>}
    </div>
  );
}
